// تهيئة الغلاف الأصلي (Capacitor) ومزامنته مع الثيم.
//
// السبب الأول: أندرويد 15 فأحدث يفرض الرسم من حافة إلى حافة على التطبيقات
// التي تستهدف SDK 35، فكانت أزرار الترويسة تُرسم تحت شريط حالة النظام.
//
// السبب الثاني: شريط الحالة لا يعرف بالثيم، فبعد تحويل التطبيق إلى مظهر
// فاتح بقي نصّه أبيض على خلفية فاتحة — غير مقروء.

export const isNative = () =>
  typeof window !== 'undefined' && Boolean(window.Capacitor?.isNativePlatform?.());

const statusBar = () => window.Capacitor?.Plugins?.StatusBar ?? null;

/**
 * يزامن شريط الحالة مع الثيم الحالي.
 * @param {{ mode: 'light'|'dark', tokens: { paper: string } }} theme
 */
export async function syncStatusBar(theme) {
  const plugin = statusBar();
  if (!plugin || !theme) return;

  try {
    const hex = rgbToHex(theme.tokens.paper);
    await plugin.setBackgroundColor({ color: hex });
    // في Capacitor: Style.Light تعني محتوى داكن على خلفية فاتحة،
    // و Style.Dark تعني محتوى فاتح. التسمية معكوسة عمّا يتوقعه الحدس.
    await plugin.setStyle({ style: theme.mode === 'light' ? 'LIGHT' : 'DARK' });

    // حفظ الثيم في SharedPreferences ليتم تطبيقه فوراً عند إقلاع APK دون وميض
    if (window.Capacitor?.Plugins?.AppSettings?.saveTheme) {
      window.Capacitor.Plugins.AppSettings.saveTheme({
        bg: hex,
        mode: theme.mode,
        id: theme.id,
      }).catch(() => {});
    }
  } catch (err) {
    console.warn('تعذر مزامنة شريط الحالة:', err);
  }
}

/**
 * يسلّم أندرويد جدول الثيم التلقائي، ليلوّن النافذة في الإقلاع بثيم
 * اللحظة الحاضرة لا بآخر ثيم رُئي.
 * @param {Array<[number, string, string, string]>} schedule
 * @param {string} choice 'auto' أو معرّف ثيم ثابت
 */
export function saveNativeThemeSchedule(schedule, choice) {
  const plugin = window.Capacitor?.Plugins?.AppSettings;
  if (!isNative() || !plugin?.saveTheme) return;
  plugin
    .saveTheme({
      choice,
      schedule: schedule.map(([at, , hex, mode]) => `${at},${hex},${mode}`).join(';'),
    })
    .catch(() => {});
}

function rgbToHex(triplet) {
  const [r, g, b] = triplet.split(' ').map(Number);
  return `#${[r, g, b].map((n) => n.toString(16).padStart(2, '0')).join('')}`;
}

export async function setupNativeShell() {
  if (!isNative()) return;

  const plugin = statusBar();
  if (plugin) {
    try {
      // لا ترسم الواجهة تحت شريط الحالة
      await plugin.setOverlaysWebView({ overlay: false });
    } catch (err) {
      console.warn('تعذر ضبط شريط الحالة:', err);
    }
  }

  const SplashScreen = window.Capacitor?.Plugins?.SplashScreen;
  if (SplashScreen) {
    try {
      await SplashScreen.hide();
    } catch {
      /* غير مثبّت — تجاهل */
    }
  }
}
